module.exports = __webpack_public_path__ + "img/DE05773.37d58163.png";